module.exports = __webpack_public_path__ + "static/media/rotaryDraw_bg2.c6da267e.png";